import { UOMS_ORDER } from "../constants"

import { UOM_RENDER_PRECISION } from "@/constants/formats"
import {
  type CompanyDefaultUnitOfMeasurement,
  type PurchaseOrderCalculatedTotals,
  type UnitOfMeasurement,
} from "@/graphql/codegen/graphql"
import { formatNumber } from "@/utils/number"

export function formatUomLabel(uom?: UnitOfMeasurement): string {
  return `${(uom?.description ?? "-").replace("(s)", "").replace(/\b\w/g, (char) => char.toUpperCase())}s (${uom?.name ?? "-"})`
}

export const buildPackagingSummaries = ({
  totals,
  units,
}: {
  totals?: PurchaseOrderCalculatedTotals | null
  units: UnitOfMeasurement[]
}): {
  header: string
  value: string
}[] => {
  const palletTotalSummary = {
    header: "Pallets",
    value: formatNumber(totals?.pallets ?? 0, UOM_RENDER_PRECISION) || "-",
  }

  if (!totals) {
    return [palletTotalSummary]
  }

  const uomsTotals = [
    {
      uomId: totals.us.uomId,
      value: totals.us.amount,
    },
    {
      uomId: totals.usExtra?.uomId,
      value: totals.usExtra?.amount,
    },
    {
      uomId: totals.metric.uomId,
      value: totals.metric.amount,
    },
    {
      uomId: totals.metricExtra?.uomId,
      value: totals.metricExtra?.amount,
    },
  ]
    .filter(({ value, uomId }) => value !== undefined && uomId !== "")
    .sort((a, b) => {
      const indexA = UOMS_ORDER.indexOf(a.uomId as CompanyDefaultUnitOfMeasurement)
      const indexB = UOMS_ORDER.indexOf(b.uomId as CompanyDefaultUnitOfMeasurement)

      const orderA = indexA === -1 ? UOMS_ORDER.length : indexA
      const orderB = indexB === -1 ? UOMS_ORDER.length : indexB
      return orderA - orderB
    })
    .map(({ uomId, value }) => ({
      header: formatUomLabel(units.find(({ id }) => id === uomId)),
      value: formatNumber(value ?? 0, UOM_RENDER_PRECISION),
    }))

  return [palletTotalSummary, ...uomsTotals]
}
